export default function SuitableCompanies() {
  const sectors = [
    { icon: 'ri-building-2-line', name: 'Производство' },
    { icon: 'ri-ship-line', name: 'Логистика' },
    { icon: 'ri-code-s-slash-line', name: 'IT и SaaS' },
    { icon: 'ri-tools-line', name: 'Инжиниринг' },
    { icon: 'ri-store-2-line', name: 'Дистрибьюторы' },
    { icon: 'ri-shopping-basket-2-line', name: 'Оптовая торговля' },
    { icon: 'ri-building-4-line', name: 'Строительство' },
    { icon: 'ri-heart-pulse-line', name: 'Медицинские услуги' },
    { icon: 'ri-briefcase-line', name: 'Консалтинг' },
    { icon: 'ri-bank-line', name: 'Финансовые услуги' },
    { icon: 'ri-building-line', name: 'Промышленность' },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-building-2-line"></i>
            Отраслевая экспертиза
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Для каких компаний подходит
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Методика B2B-продаж адаптируется под специфику отрасли, продукта и цикла сделки. Мы работали со всеми перечисленными секторами.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4 max-w-5xl mx-auto mb-10">
          {sectors.map((item, i) => (
            <div key={i} className="bg-white rounded-xl p-4 md:p-5 text-center hover:bg-teal-50 transition-colors group cursor-default border border-gray-100">
              <div className="w-12 h-12 bg-teal-600/10 rounded-xl flex items-center justify-center flex-shrink-0 mx-auto mb-3 group-hover:bg-teal-600/15 transition-colors">
                <i className={`${item.icon} text-xl text-teal-600`}></i>
              </div>
              <span className="text-sm font-medium text-gray-700 group-hover:text-teal-700 transition-colors">{item.name}</span>
            </div>
          ))}
        </div>

        <div className="max-w-3xl mx-auto text-center">
          <div className="bg-teal-600/5 rounded-2xl p-6 border border-teal-100">
            <p className="text-base text-gray-700 leading-relaxed">
              <strong className="text-teal-700">И любой бизнес со сложной сделкой.</strong> Если ваш цикл продажи занимает недели или месяцы, если в принятии решения участвуют несколько человек, если цена — не единственный фактор выбора — эта программа для вас.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}